let util = {
  dayTime: 24 * 60 * 60 * 1000,
  type(obj) {
    return Object.prototype.toString.call(obj);
  },
  isObject(obj) {
    return this.type(obj) === "[object Object]";
  },
  isArray(obj) {
    return this.type(obj) === "[object Array]";
  },
  isString(obj) {
    return this.type(obj) === "[object String]";
  },
  isNumber(obj) {
    return this.type(obj) === "[object Number]";
  },
  isDate(obj) {
    return this.type(obj) === "[object Date]";
  },
  isFunction(obj) {
    return this.type(obj) === "[object Function]";
  },
  isEqual(a = {}, b = {}) {
    return JSON.stringify(a) === JSON.stringify(b);
  },
  equal(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  },
  getParamByUrl(name, url) {
    if (!url) url = window.location.href;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  /**
   * 获取指定范围的随机数
   * @param min
   * @param max
   * @returns {*}
   */
  random(min, max) {
    return Math.round(Math.random() * (max - min)) + min;
  },
  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  },
  /**
   * 克隆对象
   * @param obj
   * @returns {*}
   */
  clone(obj) {
    if (this.isObject(obj)) {
      let result = {};
      for (let key in obj) {
        const prop = obj[key];
        result[key] = this.clone(prop);
      }
      return result;
    } else if (this.isArray(obj)) {
      let result = [];
      for (let i = 0; i < obj.length; i++) {
        const item = obj[i];
        result.push(this.clone(item));
      }
      return result;
    } else {
      return obj;
    }
  },
  mergeObject(defaults, option) {
    defaults = defaults || {};
    option = option || {};
    for (let prop in defaults) {
      if (this.isObject(defaults[prop])) {
        option[prop] = option[prop] ? option[prop] : {};
        this.mergeObject(defaults[prop], option[prop]);
      } else if (this.isArray(defaults[prop])) {
        if (!option[prop] || option[prop] === []) {
          option[prop] = defaults[prop];
        } else {
          let i = 0;
          let optLenght = option[prop].length;
          let defaultLength = defaults[prop].length;
          for (i; i < optLenght && i < defaultLength; i++) {
            option[prop][i] = this.mergeObject(
              defaults[prop][i],
              option[prop][i]
            );
          }
        }
      } else {
        option[prop] =
          option[prop] === null || option[prop] === undefined
            ? defaults[prop]
            : option[prop];
      }
    }
    return option;
  },
  /**
   * 将数字转为千分位分割格式
   * @param num
   * @returns {string}
   */
  toThousands(num) {
    let source = String(num).split("."); // 按小数点分成2部分
    source[0] = source[0].replace(
      new RegExp("(\\d)(?=(\\d{3})+$)", "ig"),
      "$1,"
    ); // 只将整数部分进行都好分割
    return source.join("."); // 再将小数部分合并进来
  },
  /**
   * 为单数前补0
   * @param num
   * @returns {string}
   */
  toDoubleNumber(num) {
    num += "";
    return num > 9 ? num : "0" + num;
  },
  /**
   * 日期格式化
   * @param date
   * @param formatter
   * @returns {string}
   */
  dateFormat(date = new Date(), formatter = "yyyy-mm-dd") {
    return formatter
      .replace("yyyy", date.getFullYear())
      .replace("mm", this.toDoubleNumber(date.getMonth() + 1))
      .replace("dd", this.toDoubleNumber(date.getDate()));
  },
  /**
   * 日期格式化
   * @param date
   * @param formatter
   * @returns {string}
   */
  timeFormat(date = new Date(), formatter = "hh:mm:ss", autoShort) {
    if (this.isDate(date)) {
      return formatter
        .replace("hh", this.toDoubleNumber(date.getHours()))
        .replace("mm", this.toDoubleNumber(date.getMinutes()))
        .replace("ss", this.toDoubleNumber(date.getSeconds()));
    } else if (this.isNumber(date)) {
      if (date < 10000) return date + "ms";
      // formatter 格式化规则 如:{s:'秒', h:'小时', m: '分钟'}
      let s = parseInt(date / 1000);
      let m = parseInt(s / 60);
      let h = parseInt(m / 60);
      s = s - m * 60;
      m = m - h * 60;
      if (!h && autoShort) {
        formatter = formatter.replace(/hh\S*?mm/, "mm");
        if (!m) {
          formatter = formatter.replace(/mm\S*?ss/, "ss");
          return formatter.replace("ss", s);
        }
      }
      return formatter
        .replace("hh", this.toDoubleNumber(h))
        .replace("mm", this.toDoubleNumber(m))
        .replace("ss", this.toDoubleNumber(s));
    }
  },
  /**
   * 格式化store中常量的值：actions、getters、mutations
   * @param constant
   * @param prefix
   */
  initializeConstants(constant, prefix) {
    for (let prop in constant) {
      let val = constant[prop];
      if (util.isObject(val)) {
        this.initializeConstants(val, `${prefix}-${prop}`);
      } else {
        constant[prop] = `${prefix}-${prop}`;
      }
    }
  },
  /**
   * 从中间拆分字符串,长度超出的话，解析为xxx...xxx
   * @param str
   * @param config
   * @returns {string}
   */
  strMiddleSplit(
    str,
    config = {
      maxLength: 20,
      beginLength: 8,
      endLength: 8,
      replaceStr: "..."
    }
  ) {
    str += "";
    let reg = {
      // eslint-disable-next-line
      fullCharReg: /[^\x00-\xff]/,
      // eslint-disable-next-line
      fullCharsReg: /[^\x00-\xff]/g,
      anyChars: /[\S\s]{1}/g
    };

    let fullCharLength = (str.match(reg.fullCharsReg) || []).length;
    let fullLength = str.length + fullCharLength;
    let beginArr = [];
    let beginLength = 0;
    let endArr = [];
    let endLength = 0;

    if (fullLength > config.maxLength) {
      let strArr = str.match(reg.anyChars);

      strArr.forEach(char => {
        if (beginLength >= config.beginLength) return;
        let len = reg.fullCharReg.test(char) ? 2 : 1;
        beginLength += len;
        beginArr.push(char);
      });

      strArr.reverse().forEach(char => {
        if (endLength >= config.endLength) return;
        let len = reg.fullCharReg.test(char) ? 2 : 1;
        endLength += len;
        endArr.push(char);
      });

      return beginArr.join("") + config.replaceStr + endArr.reverse().join("");
    }

    return str;
  },
  bind(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
      element.attachEvent("on" + type, handler);
    } else {
      element["on" + type] = handler;
    }
  },
  getWheelEventName() {
    return "onwheel" in document.createElement("div")
      ? "wheel"
      : document.onmousewheel !== undefined
      ? "mousewheel"
      : "DOMMouseScroll";
  },
  /**
   * 字符串转为驼峰格式, eg: a_b ==> aB
   * @param str
   * @returns {string}
   */
  toCamel(str = "") {
    let matchArr = str.match(/_\S/g) || [];
    matchArr.forEach(item => {
      str = str.replace(item, item.replace("_", "").toUpperCase());
    });
    return str;
  },
  /**
   * 将驼峰格式字符串转化为下划线格式，eg：aB ===> a_b
   * @param str
   * @returns {string}
   */
  toUnderLine(str = "") {
    let matchArr = str.match(/[A-Z]/g) || [];
    matchArr.forEach(item => {
      str = str.replace(item, "_" + item.toLowerCase());
    });
    return str;
  },
  /**
   * 转为驼峰命名规范对象
   * @param obj
   * @returns {{}}
   */
  toCamelObj(obj = {}) {
    let result = {};
    for (let key in obj) {
      if (this.isFunction(obj[key])) continue;
      result[this.toCamel(key)] = obj[key];
    }
    return result;
  },
  /**
   * 转为下划线命名规范对象
   * @param obj
   * @returns {{}}
   */
  toUnderLineObj(obj = {}) {
    let result = {};
    for (let key in obj) {
      if (this.isFunction(obj[key])) continue;
      result[this.toUnderLine(key)] = obj[key];
    }
    return result;
  },
  haveUserGroup(userGroup) {
    if (!userGroup || userGroup === 0 || userGroup === "0") return false;
    return true;
  },
  /**
   * 日期时间格式化
   * @param date
   * @param formatter
   * @returns {string}
   */
  dateTimeFormat(date = new Date(), formatter = "yyyy-mm-dd hh:mm:ss") {
    formatter = formatter.split("hh");
    return (
      this.dateFormat(date, formatter[0]) +
      this.timeFormat(date, "hh" + formatter[1])
    );
  },
  /**
   * 获取字符串长度，区分中英文
   * @param str
   * @returns {number}
   */
  getStrFullLength(str) {
    /* eslint-disable no-control-regex */
    let reg = {
      fullCharReg: /[^\x00-\xff]/,
      fullCharsReg: /[^\x00-\xff]/g,
      anyChars: /[\S\s]{1}/g
    };

    let fullCharLength = (str.match(reg.fullCharsReg) || []).length;
    let fullLength = str.length + fullCharLength;
    return fullLength;
  },
  /**
   * 获取附加指标展示规则
   * @param param
   * @returns {{showTotal: boolean | *, showTongbi: boolean}}
   */
  getExtendShowRule(param, chartType) {
    let singleGroup = param.data.user_group.split(",").length === 1; // 多用户群对比
    let haveGroup = this.haveUserGroup(param.user_group);
    let haveDimension = param.data.dimension_sub;
    let haveCondition = param.data.filter_condition;
    let newChartType = chartType.split(",")[1];
    chartType = newChartType || chartType;
    let showTotal =
      ["grid", "line", "bar", "map"].includes(chartType) || // 图表类型是表格、趋势图或者汇总图、地图
      param.data.module === "duration" ||
      (chartType === "pie" && (haveDimension || haveCondition)) || // 图表类型是占比图，并且有属性细分或者筛选条件
      (chartType === "number" &&
        !haveDimension &&
        !haveCondition &&
        param.data.module !== "duration_avg" &&
        (singleGroup || !haveGroup)); // 图表类型是数值类型，并且没有属性细分，没有用户群对比
    let showTongbi = /number/.test(chartType);
    if (param.data.module === "diy") {
      // 自定义指标
      showTotal = false;
      showTongbi = true;
    }
    return {
      showTotal,
      showTongbi,
      showHuanbi: true
    };
  },
  haveUserGroup(userGroup) {
    if (!userGroup || userGroup === 0 || userGroup === "0") return false;
    return true;
  },
  sortData(queryParam, data) {
    let haveGroup = this.haveUserGroup(queryParam.user_group);
    // 对指标名称进行转换
    if (queryParam.module === "duration_avg") {
      data.series.forEach(item => {
        item.names.forEach((name, i) => {
          if (name === "使用时长") item.names[i] = "平均使用时长";
        });
      });
    }
    if (haveGroup) {
      /**
       * 首先把相同用户群的归为一类
       */
      let groups = {
        originList: []
      };
      data.series.forEach(item => {
        let groupName = item.names[1];
        if (!groups[groupName]) {
          let group = (groups[groupName] = {});
          group.list = [];
          group.count = 0;
          groups.originList.push(group);
        }
        groups[groupName].list.push(item);
        item.values.forEach(value => {
          groups[groupName].count += value;
        });
      });
      /**
       * 对每一类用户群进行总和排序
       */
      groups.originList.sort((a, b) => {
        return b.count - a.count;
      });
      /**
       * 将排序后的列表拆解成原始列表结构
       */
      data.series = [];
      groups.originList.forEach((group, groupIndex) => {
        group.list.forEach(function(series) {
          series.groupIndex = groupIndex;
          data.series.push(series);
        });
      });
    } else {
      data.series.sort(function(a, b) {
        let valuesA = 0;
        let valuesB = 0;
        a.values.forEach(function(value) {
          valuesA += value;
        });
        b.values.forEach(function(value) {
          valuesB += value;
        });
        return valuesB - valuesA;
      });
    }
    return data;
  },
  getColorByName(name) {
    const colors = [
      "#00a0e9",
      "#aaabd3",
      "#f4b93b",
      "#85bd41",
      "#f29c9f",
      "#0068b7",
      "#f29b76",
      "#ea68a2",
      "#8f82bc",
      "#f29b76"
    ];
    if (!name) return colors[0];
    let num = 0;
    for (let i = 0; i < name.length; i++) {
      num += name.charCodeAt(i);
    }
    num = num + "";
    return colors[num.charAt(num.length - 1)];
  },
  copy(text, onSuccess, onError) {
    let id = "zgClipboardInput";
    if (!document.getElementById(id)) {
      let input = document.createElement("input");
      input.type = "text";
      input.id = id;
      input.style = "position: fixed; top: -9999999px; z-index: -9999999";
      document.body.appendChild(input);
    }
    let input = document.getElementById(id);
    input.value = text;
    input.focus();
    input.setSelectionRange(0, text.length);
    let result = false;
    result = document.execCommand("copy", true);
    if (result) {
      if (this.isFunction(onSuccess)) {
        onSuccess();
      }
    } else {
      if (this.isFunction(onError)) {
        onError();
      }
    }
  }
};

export default util
